
/**
 * 这里放开关配置
 */
export default {
  enableShiplyAbTestTag: true,
  enableAbTestTag: true,
  enableShiplyTag: true,
  enableTapd: true,
  enableBatchCancel: true,
  enableTapdHandler: true,
  enableGPT: true,
  enableComplianceAnalyticTab: true,
  enableComplianceIssueSetting: true,
  enablePreviewSourceCode: false,
};
